import {toCamelCase} from 'case-converter'
import {
  assignPrices,
  filterByValues,
  switchMbToGb,
  specifyVbrBackupsStoragePrices,
  checkPricesWarnings, fetchSynchronizer, fetchErrorsHandler, fetchStart, fetchSuccessful, getFetchDate
} from '~/helpers/prices/_utils/prices'
import {clonePrices} from '~/helpers/prices/vmware/_clone-prices'
import {Resource, Group} from '~/helpers/prices/vmware/enum'

export const state = () => ({
  pricesVmware: [],
  pricesForConfigurator: [],
  vmwareFetchDate: '',
  fetchingNow: false,
  fetchingResult: ''
})

export const mutations = {
  setVmwarePrices(state, value) {
    state.pricesVmware = value
  },
  setPricesForConfigurator(state, value) {
    state.pricesForConfigurator = specifyVbrBackupsStoragePrices(value)
  },
  setVmwareFetchDate(state, value) {
    state.vmwareFetchDate = value
  },
  setFetchingState(state, value) {
    state.fetchingNow = value
  },
  setFetchingResult(state, value) {
    state.fetchingResult = value
  }
}

export const actions = {
  async fetchVmwarePrices({commit, state}, options) {
    if (state.fetchingNow) {
      return fetchSynchronizer(commit, state)
    } else {
      fetchStart(commit)

      return this.$http.$get('https://api.selectel.ru/prices/vmware?currency=rub', options)
        .then(res => toCamelCase(res))
        .then(prices => assignPrices(prices, clonePrices, ['group', 'resource']))
        .then(prices => checkPricesWarnings(prices))
        .then(prices => switchMbToGb(prices))
        .then(prices => {
          commit('setVmwarePrices', prices)

          commit('setVmwareFetchDate', getFetchDate())

          fetchSuccessful(commit)

          return prices
        })
        .catch(err => fetchErrorsHandler(commit, err))
    }
  },

  async fetchVmwarePricesForConfigurator({state, dispatch, commit}) {
    if (!state.pricesVmware.length) {
      await dispatch('fetchVmwarePrices')
    }

    commit('setPricesForConfigurator', [...state.pricesVmware])
  }
}

export const getters = {
  getVmwareFetchDate(state) {
    return state.vmwareFetchDate
  },
  getVmwarePrices(state) {
    return state.pricesVmware
  },
  getVmwarePricesForConfigurator(state) {
    return state.pricesForConfigurator
  },
  getVmwareBackupsPrices(state) {
    return filterByValues(
      state.pricesVmware,
      [
        {
          key: 'resource',
          values: [Resource.VBR_BACKUPS_STORAGE, Resource.VBR_BACKUPS_CNT]
        },
        {
          key: 'group',
          values: [Group.SPB_GOLD_1_DR]
        }
      ]
    )
  }
}
